<table class="table-fixed w-full table-striped">
  <thead class="h-[50px] w-full !z-30 sticky top-0 bg-[#1A4971]">
    <tr class="bg-muted text-muted-foreground text-[#343A40] bg-[#DEE2E6]">
      <th class="p-2 pl-[2rem] !font-Roboto !text-left">ID</th>
      <th class="p-2 !font-Roboto !text-left">Permission Name</th>
      <th class="p-2 !text-left">Roles</th>
      <th class="p-2 !text-left">Action</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngIf="permissions && permissions?.length > 0">
      <tr
        *ngFor="let permission of permissions; let i = index"
        class="hover:bg-muted/50 !font-Roboto !cursor-default !h-[43px]"
      >
        <td class="border-b p-2 pl-[2rem] !text-left cursor-pointer">
          {{ permission?.id }}
        </td>
        <td class="border-b p-2 !text-left">
          {{ permission?.name }}
        </td>
        <td class="border-b p-2 !text-left">
          <span *ngIf="permission.roles && permission.roles.length > 0">
            {{ getRoleNames(permission.roles) }}
          </span>
        </td>
        <td class="border-b p-2 !text-left">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <!-- <button mat-menu-item (click)="editPermission(permission)">
              <mat-icon color="primary">edit</mat-icon> Edit
            </button>
            <button mat-menu-item (click)="deletePermission(permission?.id)">
              <mat-icon color="warn">delete</mat-icon> Delete
            </button> -->
            <button
              mat-menu-item
              (click)="openViewDetailDialog(permission)"
              class="!mb-[3px]"
            >
              <mat-icon class="!text-[#e76b3f]">visibility</mat-icon>
              <span>View Details</span>
            </button>
          </mat-menu>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
<!-- Empty State -->
<div *ngIf="permissions.length === 0" class="empty-state">
  No permissions found. Please add a new permission.
</div>

<!-- Inline Permission Dialog Template -->
<ng-template #addPermissionDialog>
  <div
    class="flex justify-between items-center gap-8 sticky top-0 !bg-[#dee2e6] p-6"
  >
    <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
      <h3 class="header-title">
        {{
          editPermissionId ? "Update Existing Permission" : "Add New Permission"
        }}
      </h3>
    </div>
    <!-- Close Icon -->
    <div
      style="position: absolute; top: 10px; right: 36px; z-index: 50"
      (click)="closeDialog()"
    >
      <img
        src="assets/icons/cross-icon.svg"
        alt="cross icon"
        class="cursor-pointer !fixed"
      />
    </div>
  </div>
  <div class="inline-dialog">
    <form [formGroup]="permissionForm" (ngSubmit)="createPermission()">
      <div class="grid grid-cols-2 gap-4">
        <!-- First Name -->
        <div>
          <mat-form-field class="w-full" appearance="outline">
            <mat-label>Permission Name</mat-label>
            <input
              matInput
              type="text"
              id="permissionName"
              formControlName="permissionName"
              placeholder="Enter Permission ame"
            />
            <mat-error
              *ngIf="
                permissionForm.get('permissionName')?.invalid &&
                permissionForm.get('permissionName')?.touched
              "
            >
              Permission Name is required
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Role Selection (Multi-Select) -->
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Select Roles</mat-label>
          <mat-select formControlName="roles" multiple>
            <mat-option *ngFor="let role of roles" [value]="role.id">
              {{ role.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Form Actions -->
      <div class="dialog-actions">
        <button
          class="submit-btn"
          type="submit"
          [disabled]="permissionForm.invalid"
        >
          {{ editPermissionId ? "Update Permission" : "Add Permission" }}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<!-- Role Detail Dialog Template -->
<ng-template #viewDetailDialog>
  <div
    class="flex justify-between items-center gap-8 sticky top-0 !bg-[#dee2e6] p-6"
  >
    <div class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]">
      <h3 class="header-title">
        {{ permissionDetail?.name }} - is assigned to the following roles:
      </h3>
    </div>
    <!-- Close Icon -->
    <div
      style="position: absolute; top: 10px; right: 36px; z-index: 50"
      (click)="closeDialog()"
    >
      <img
        src="assets/icons/cross-icon.svg"
        alt="cross icon"
        class="cursor-pointer !fixed"
      />
    </div>
  </div>
  <div class="inline-dialog">
    <div class="grid grid-cols-2 gap-4 bg-gray-100 p-4 rounded-lg shadow-md">
      <div
        *ngFor="let role of permissionDetail?.roles"
        class="bg-white p-3 rounded-lg shadow-sm border border-gray-200 text-gray-700 text-sm font-medium"
      >
        {{ role?.name | titlecase }}
      </div>
    </div>
  </div>
</ng-template>
